module.exports = __webpack_public_path__ + "img/al.b8c8240f.svg";